// Mapping dạng toán theo lớp, chương, bài

export interface DangToanMetadata {
  tenBai: string
  cacDang: string[]
}

export const DANG_TOAN_MAPPING: Record<string, DangToanMetadata> = {
  // LỚP 11 - CHƯƠNG 1: DAO ĐỘNG
  'L11_C1_B1': {
    tenBai: 'Mô tả dao động',
    cacDang: [
      'Khái niệm dao động cơ',
      'Chu kỳ, tần số, biên độ',
      'Dao động tự do',
      'Dao động cưỡng bức'
    ]
  },
  'L11_C1_B2': {
    tenBai: 'Dao động điều hòa',
    cacDang: [
      'Phương trình dao động x = Acos(ωt + φ)',
      'Vận tốc và gia tốc trong dao động điều hòa',
      'Con lắc lò xo',
      'Con lắc đơn',
      'Chu kỳ và tần số dao động'
    ]
  },
  'L11_C1_B3': {
    tenBai: 'Năng lượng dao động',
    cacDang: [
      'Động năng và thế năng',
      'Cơ năng bảo toàn',
      'Biểu đồ năng lượng',
      'Năng lượng con lắc lò xo',
      'Năng lượng con lắc đơn'
    ]
  },
  'L11_C1_B4': {
    tenBai: 'Tổng hợp dao động',
    cacDang: [
      'Tổng hợp hai dao động cùng phương',
      'Phương pháp Fresnel',
      'Biên độ dao động tổng hợp'
    ]
  },
  'L11_C1_B5': {
    tenBai: 'Dao động tắt dần và cưỡng bức',
    cacDang: [
      'Dao động tắt dần',
      'Dao động duy trì',
      'Dao động cưỡng bức',
      'Hiện tượng cộng hưởng'
    ]
  },
  
  // LỚP 10 - CHƯƠNG 1
  'L10_C1_B5': {
    tenBai: 'Chuyển động thẳng đều',
    cacDang: [
      'Phương trình chuyển động',
      'Vận tốc trung bình',
      'Đồ thị chuyển động'
    ]
  },
  
  // LỚP 12 - CHƯƠNG 1
  'L12_C1_B5': {
    tenBai: 'Dao động điều hòa nâng cao',
    cacDang: [
      'Phương trình dao động phức tạp',
      'Năng lượng dao động',
      'Tổng hợp dao động'
    ]
  }
}

export const getDangToanOptions = (lop: number, chuong: number, bai: number): string[] => {
  const key = `L${lop}_C${chuong}_B${bai}`
  return DANG_TOAN_MAPPING[key]?.cacDang || []
}

export const getTenBai = (lop: number, chuong: number, bai: number): string => {
  const key = `L${lop}_C${chuong}_B${bai}`
  return DANG_TOAN_MAPPING[key]?.tenBai || `Bài ${bai}`
}

export const getChuongName = (lop: number, chuong: number): string => {
  const chuongNames: Record<string, Record<number, string>> = {
    '11': {
      1: 'Dao động',
      2: 'Sóng',
      3: 'Điện xoay chiều',
      4: 'Dao động và sóng điện từ'
    },
    '10': {
      1: 'Động học chất điểm',
      2: 'Động lực học chất điểm',
      3: 'Cân bằng và chuyển động của vật rắn',
      4: 'Các định luật bảo toàn'
    },
    '12': {
      1: 'Dao động cơ',
      2: 'Sóng cơ và sóng âm',
      3: 'Dòng điện xoay chiều',
      4: 'Dao động và sóng điện từ'
    }
  }
  
  return chuongNames[String(lop)]?.[chuong] || `Chương ${chuong}`
}

export const getBaiListForChuong = (lop: number, chuong: number): number[] => {
  const baiSet = new Set<number>()
  
  Object.keys(DANG_TOAN_MAPPING).forEach(key => {
    const match = key.match(/^L(\d+)_C(\d+)_B(\d+)$/)
    if (match) {
      const [, l, c, b] = match
      if (parseInt(l) === lop && parseInt(c) === chuong) {
        baiSet.add(parseInt(b))
      }
    }
  })
  
  return Array.from(baiSet).sort((a, b) => a - b)
}

